import moment from "moment";
import ConfirmationModal from "../../components/ConfirmationModal";

const RejectConfirmationModal = ({
    data,
    note,
    processingAction,
    onClose,
    onConfirm,
}) => {
    const versionLabel = data?.date
        ? `Modification on ${moment.tz(data.date, "Asia/Tokyo").locale("en").format("MMM D, YYYY H:mm")}`
        : "Modification on -";

    return (
        <ConfirmationModal
            show
            size="modal-lg"
            title="Are you sure you want to reject this booking modification?"
            variant="danger"
            confirmLabel="Reject"
            busyLabel="Processing..."
            cancelLabel="Back"
            isBusy={processingAction === "rejected"}
            onCancel={onClose}
            onConfirm={onConfirm}
        >
            <div className="tw:flex tw:flex-col tw:gap-5 tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-[#F9F9F9] tw:px-5 tw:py-4">
                <div>
                    <div className="tw:mb-2 tw:font-hanken-grotesk tw:text-[13px] tw:text-[#8D8D8D]">
                        Version History
                    </div>
                    <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:text-[#282828]">
                        {versionLabel}
                    </div>
                </div>
                <div>
                    <div className="tw:mb-2 tw:font-hanken-grotesk tw:text-[13px] tw:text-[#8D8D8D]">
                        Rejection Message
                    </div>
                    <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-[400] tw:leading-[22px] tw:text-[#282828]">
                        {note || "-"}
                    </div>
                </div>
            </div>
        </ConfirmationModal>
    );
};

export default RejectConfirmationModal;
